"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactsScreenEnum = void 0;
var ContactsScreenEnum;
(function (ContactsScreenEnum) {
    ContactsScreenEnum["ShowContactsOnly"] = "showContactsOnly";
    ContactsScreenEnum["ShowCustomersOnly"] = "showCustomersOnly";
    ContactsScreenEnum["ShowContactsAndCustomer"] = "showContactsAndCustomer";
})(ContactsScreenEnum = exports.ContactsScreenEnum || (exports.ContactsScreenEnum = {}));
//# sourceMappingURL=ContactsScreenEnum.js.map